export default __webpack_public_path__ + "static/media/surprise.50fedc8b.jpg";